import { Component, OnInit, Input, ApplicationRef } from '@angular/core';
import { LocaleService, TranslationService } from 'angular-l10n';
import { AppSidebarFilterService } from './app-sidebar-filter.service';
import { AuthenticationService } from '../../views/authentication/authentication.service';

@Component({
  selector: 'app-sidebar-filter',
  templateUrl: './app-sidebar-filter.component.html',
  styleUrls: ['./app-sidebar-filter.component.css']
})
export class AppSidebarFilterComponent implements OnInit {

  @Input() accounts: string[] = [];
  @Input() costCenters: any[] = [];
  @Input() carriers: any[] = [];
  @Input() corporateUnits: any[] = [];
  @Input() people: any[] = [];
  @Input() tenants: any[] = [];
  @Input() holdings: any[] = [];
  @Input() chargeTypes: string[] = [];
  @Input() networks: string[] = ['Facebook & Twitter', 'WhatsApp'];
  @Input() locations: string[] = ['National', 'International'];

  charge_max: number = 3000;
  filtered_holdings: any[] = [];
  selected_filters: any = {};

  constructor(private locale: LocaleService, private translation: TranslationService, private appRef: ApplicationRef,
    private service: AppSidebarFilterService, private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.authenticationService.authenticationChanged.subscribe(item => {
      if (this.authenticationService.isLogged)
        this.getFilters();
    });
    this.service.filterData.subscribe(item => {
      if(item.filter_received) {
        this.selected_filters = item;
      }
    });
  }

  getFilters() {
    this.service.getCarriersLabels().subscribe(response => {
      this.carriers = response;
    });
    this.service.getChargeTypes().subscribe(response => {
      this.chargeTypes = response;
    });
    this.service.getAccounts().subscribe(response => {
      this.accounts = response;
    });
    this.service.getCorporateUnits().subscribe(response => {
      this.corporateUnits = response;
    });
    this.service.getPeople().subscribe(response => {
      this.people = response;
    });
    this.service.getCostCenters().subscribe(response => {
      this.costCenters = response;
    });
    this.service.getTenants().subscribe(response => {
      this.tenants = response;
    });
    this.service.getHoldings().subscribe(response => {
      this.holdings = response;
      this.filtered_holdings = response;
    });
  }

  filterHoldings(holding, tenant) {
    const selected_tenants = tenant.selectedOptions.selected.map(item => item.value.id).join(',');
    const selected_holdings = holding.selectedOptions.selected.map(item => item.value.id).join(',');
    // let selectedOptions = holding.selectedOptions.selected;
    if (selected_tenants && selected_tenants.length > 0) {
      this.filtered_holdings = this.holdings.filter(item => {
        return selected_tenants.indexOf(item.id) >= 0 || selected_holdings.indexOf(item.id) >= 0;
      });
    } else {
      this.filtered_holdings = this.holdings;
    }
    setTimeout(() => {
      holding.options.map(item => {
        item.selected = selected_holdings.indexOf(item.value.id) >= 0;
      });
      this.appRef.tick();
    }, 1);
  }

  submit(costCenter, carrier, network, location, tenant, holding, chargeType, charge, account) {
    let filter: any = {filter_sent:true},
    filter_carrier = carrier.selectedOptions.selected.map(item => item.value) || [],
    filter_account = account.selectedOptions.selected.map(item => item.value) || [],
    filter_chargeType = chargeType.selectedOptions.selected.map(item => item.value) || [],
    //filter_costCenter = costCenter.selectedOptions.selected.map(item => item.value) || [],
    //filter_network = network.selectedOptions.selected.map(item => item.value) || [],
    //filter_location = location.selectedOptions.selected.map(item => item.value) || [],
    filter_tenant = tenant.selectedOptions.selected.map(item => item.value.tenantID) || [];
    //filter_holding = holding.selectedOptions.selected.map(item => item.value) || [],


    if (filter_carrier.length > 0)
      filter.carrier = filter_carrier;
    if (filter_account.length > 0)
      filter.account = filter_account;
    if (filter_chargeType.length > 0)
      filter.chargeType = filter_chargeType;
      if (filter_tenant.length > 0)
        filter.tenant = filter_tenant;
    /*if (filter_costCenter.length > 0)
      filter.costCenter = filter_costCenter;
    if (filter_network.length > 0)
      filter.network = filter_network;
    if (filter_location.length > 0)
      filter.location = filter_location;

    if (filter_holding.length > 0)
      filter.holding = filter_holding;*/


    if (charge.value) filter.charge = charge.value;

    console.log('filter', filter);
    this.selected_filters = filter;
    this.service.setFilterData(filter);
  }

  isSelected(item,filterItem) {
    if (!filterItem) return true ;
    let filteredItem = filterItem.filter(obj=> {
      if(obj.id)
        return obj.id === item.id ;
      else return obj === item;
    });
    return filteredItem && filteredItem.length > 0;
  }

  selectAll(event, item) {
    if (event.selected) {
      item.selectAll();
    } else {
      item.deselectAll();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar-filter/app-sidebar-filter.component.ts